import { useEffect } from "react"
import { useLocation } from "react-router-dom"

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * whenever the route pathname changes. This fixes the issue where navigating
 * between pages (Course > Modules > Lessons > Questions) would keep the
 * scroll position from the previous page.
 */
const ScrollToTop = () => {
	const { pathname } = useLocation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	return null
}

export default ScrollToTop
